module.exports = __webpack_public_path__ + "img/thumb_08.96d57577.jpg";